import React from 'react'
import {
	CardHeader,
	ActionsContainer,
	CardDescription,
	CardMeta,
	IconWrapper,
	CardMetaTags,
	CardMetaTagsContainer,
	CardActions,
	IconPreviewWrapper,
    StyledCard,
} from './SlideoutDriveCard.styled';
import {Typography, Checkbox, Icon } from '@ann/web-components';

const SlideoutDriveCard = ({title, description, ownerName, version, lock, documents, onDriveClick, icon="folder", checked, onChange}) =>{
	
	const handleToggleSelection = () => {
		onChange(!checked);
	}

	return (
		<StyledCard>
			<CardHeader>
				<Checkbox 
					checked={checked || false}
					onChange={handleToggleSelection}
					size="medium"
				/>
				<Icon name={icon} size="small"/>
				<Typography 
					category="title" 
					size="medium" 
					weight="bold"
					onClick={handleToggleSelection}
					style={{ cursor: 'pointer' }}
				>
					{title}
				</Typography>
			</CardHeader>
			<CardDescription>
				<Typography category="body" size="medium" weight="regular">{description}</Typography>
			</CardDescription>
			<CardMeta>
				<CardMetaTagsContainer>
					<CardMetaTags id={"test-3"}>
						<IconWrapper>
							<Icon name="group" size="small"/>
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{ownerName}</Typography>
					</CardMetaTags>
					<CardMetaTags>
						<IconWrapper>
							<Icon name="lastUpdated" size="small"/>
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{version}</Typography>
					</CardMetaTags>
					<CardMetaTags>
						<IconWrapper>
							<Icon name="lock" size="small"/>
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{lock}</Typography>
					</CardMetaTags>
					<CardMetaTags>
						<IconWrapper>
							<Icon name="filePresent" size="small"/>
						</IconWrapper>
						<Typography category="body" size="small" weight="regular">{documents}</Typography>
					</CardMetaTags>
				</CardMetaTagsContainer>
			</CardMeta>
			<CardActions>
				<IconPreviewWrapper onClick={onDriveClick} style={{cursor: 'pointer'}}>
					<Icon name="arrowRight" size="medium"/>
				</IconPreviewWrapper>
			</CardActions>
		</StyledCard>
	)
}

export default SlideoutDriveCard
